import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { TERipple } from 'tw-elements-react';
import { useAuth } from '../../context/AuthContext';
import { Link } from 'react-router-dom';
import { H1Icon } from '@heroicons/react/16/solid';
import Header from '../utils/Header'
import Footer from '../utils/Footer'
import Reservado from '../../assets/Reservado.png'
import axios from 'axios';

const ListingReserved = () => {
  const { token, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const searchParams = new URLSearchParams(location.search);
  const id = searchParams.get("id");

  const [transaction, setTransaction] = useState(null);
  const [loading, setLoading] = useState(null);
  const [error, setError] = useState(null);

  const result = location.state?.result || {};

  useEffect(() => {
    if (!id) return;

    const fetchTransaction = async () => {

      try {
        const responseTransaction = await axios.get(`https://production.wompi.co/v1/transactions/${id}`)
        setTransaction(responseTransaction.data.data);
      } catch (error) {
        setError('Error al cargar la transacción.')
      }
    }

    fetchTransaction();
  }, [id]);


  let statusText = "Estado desconocido";

  if (transaction && transaction.status) {
    if (transaction.status === "APPROVED") {
      statusText = "Pago aprobado";
    } else if (transaction.status === "DECLINED") {
      statusText = "Pago rechazado";
    } else if (transaction.status === "ERROR") {
      statusText = "Error en la transacción";
    } else if (transaction.status === "VOIDED") {
      statusText = "Pago anulado";
    }
  }

  return (
    <div >
      <Header />

      {transaction ? (
        transaction.status === "APPROVED" ? (
          <div className="flex flex-col items-center justify-center text-center py-10 px-4">
            <h1 className="text-2xl font-bold text-[#1F4F51]">¡Gracias por tu reserva!</h1>
            <img src={Reservado} alt="Reservado" className="w-20 h-20 my-4" />
            <p className="mt-1 text-base font-bold text-[#1F4F51]">Hemos recibido tu solicitud de pago.</p>
            <p className="text-base font-bold text-[#1F4F51]">Aquí encontrarás el detalle de la transacción</p>

            <h2 className="mt-3 text-2xl font-bold text-[#1F4F51]">{statusText}</h2>
            {transaction?.reference && (() => {
              const reference = transaction.reference;
              const lastValue = reference.includes("-") ? reference.split("-").pop() : reference;

              return <p className="mt-2 text-gray-700">Tu reserva ha sido confirmada con el <span className="font-bold text-[#1F4F51]">número {lastValue}</span></p>
            })()}
            <p className="mt-1 text-base font-bold text-[#1F4F51]">Referencia de pago: <span className="font-semibold text-gray-700">{transaction.id}</span></p>
            <p className="mt-2  text-base font-bold text-gray-600">
              Monto: <span className="font-semibold text-[#1F4F51]">${(transaction.amount_in_cents / 100).toFixed(2)} COP</span>
            </p>
            <p className="mt-4 text-gray-600">En breve, recibirás una <span className="font-bold">notificación</span> por correo electrónico y WhatsApp con todos los detalles de tu reserva, <span className="font-bold">incluyendo la información relevante para tu viaje.</span></p>
            <p className="mt-4 text-gray-600">Si necesitas asistencia adicional, no dudes en contactarnos.</p>
            <p className="mt-2 font-bold text-[#1F4F51]">¡Gracias por confiar en nosotros!</p>
          </div>
        ) : (
          <div className="flex flex-col items-center justify-center text-center py-10 px-4">

            <div className="max-w-2xl mx-auto bg-white shadow-md rounded-lg p-6">
              <div className="flex items-center justify-center space-x-3">
                <h2 className="text-2xl font-bold text-red-700">{statusText}</h2>
              </div>

              <div className="mt-6">
                <h3 className="bg-red-200 text-red-900 font-semibold p-2 rounded-t-md">Información de la transacción</h3>
                <div className="border border-gray-300 rounded-b-md">
                  <div className="grid grid-cols-2 p-3 border-b">
                    <p className="font-semibold">Transacción:</p>
                    <p>{transaction.id}</p>
                  </div>
                  <div className="grid grid-cols-2 p-3 border-b">
                    <p className="font-semibold">Referencia:</p>
                    <p>{transaction.reference}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )
      ) : (
        <>
          <div className="flex flex-col items-center justify-center text-center py-10 px-4">
            <div className="">
              <div className="text-white p-6 text-center animate-pulse">
                <h2 className="text-2xl font-bold text-[#1F4F51] flex items-center justify-center gap-2">
                  <span className="animate-spin">⏳</span> Cargando...
                </h2>
                <p className='text-xl font-bold text-[#1F4F51]'>Estamos obteniendo la información de la transacción.</p>
              </div>
            </div>
          </div>
        </>
      )}

      <Footer />
    </div>
  );
};

export default ListingReserved;


